import React from "react";
import SingleDistanceParamContent from "../components/distanceParams/single-distanceParam-content";

const SingleDistanceParam = () => {
  return <SingleDistanceParamContent />;
};

export default SingleDistanceParam;
